import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import useGridInputs from '../../hooks/useGridInputs';
import useUnifiedProductGridData from '../../hooks/useUnifiedProductGridData';
import {
  getAllFacetsWithSelectedUrlFilters,
  getFacetsToRenderByGridType,
  groupSizeFacets,
} from '../../utils/filters';

import DesktopGridFilterRenderer from './DesktopGridFilterRenderer';
import DesktopGridSelectedFilters from './DesktopGridSelectedFilters';

const DesktopGridFacetList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
`;

const FacetListItem = styled.li`
  border-top: 1px solid ${({ theme }) => theme.colors.gridFacetListBorderColor};
`;

const DesktopGridFilters = () => {
  const { facets, selectedUrlFilters, allRegisteredFacets, searchQuery } =
    useUnifiedProductGridData();
  const [openPanels, setOpenPanels] = useState({});
  const { gridType } = useGridInputs();

  const selectedFacets = getAllFacetsWithSelectedUrlFilters({
    selectedUrlFilters,
    allRegisteredFacets,
    facets,
    gridType,
  });

  const facetsWithSizesGrouped = groupSizeFacets(selectedFacets);

  const togglePanel = (panelId) => {
    setOpenPanels((prevState) => ({
      ...prevState,
      [panelId]: !prevState[panelId],
    }));
  };

  const closeAllPanels = () => {
    setOpenPanels({});
  };

  // close filter panels when search query changes
  useEffect(() => {
    closeAllPanels();
  }, [searchQuery]);

  const facetsToRender = getFacetsToRenderByGridType({
    gridType,
    facets: facetsWithSizesGrouped,
  });

  return (
    <>
      <DesktopGridSelectedFilters closeAllPanels={closeAllPanels} />
      <DesktopGridFacetList>
        {facetsToRender?.map((facet) => (
          <FacetListItem key={facet?.name || facet?.display_name}>
            <DesktopGridFilterRenderer
              facet={facet}
              togglePanel={togglePanel}
              openPanels={openPanels}
            />
          </FacetListItem>
        ))}
      </DesktopGridFacetList>
    </>
  );
};

export default DesktopGridFilters;
